import React from "react";
import { Field } from "formik";
import { Checkbox } from "components/Form/SpecialButtons";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";

const DegradationForm = () => (
	<div>
		<Field
			id="manualDegradation"
			name="manualDegradation"
			customlabel="Prévenir les utilisateurs que le système rencontre des problèmes."
			component={Checkbox}
			required
		/>

		<Field type="text" name="manualDegradationMessage" customlabel="Message aux utilisateurs" component={CustomInputTextComponent} />

		<Field
			id="usualState"
			name="usualState"
			customlabel="Prévenir les utilisateurs que le système est revenu à la normale."
			component={Checkbox}
			required
		/>
	</div>
);

export default DegradationForm;
